import React, { useMemo } from 'react';
import './style.scss';
import clsx from 'clsx';
import SVGLogo from '../../../assets/logo';

interface LoaderProps {
  size?: number | string;
  color?: 'white' | 'primary' | 'invalid';
  className?: string;
  onClick?: () => any;
  style?: any;
  useAbsoluteWrapper?: boolean;
  appear?: 'normal' | 'slow' | 'none';
}

const Loader = ({
  size = 120,
  color: colorCode = 'white',
  className = '',
  style,
  useAbsoluteWrapper = false,
  onClick,
  appear = 'normal'
}: LoaderProps) => {
  const wrapperClassName = useMemo<string>(() => {
    return clsx(
      'loader-wrapper',
      useAbsoluteWrapper && 'loader-wrapper-absolute',
      appear === 'normal' && 'loader-wrapper-appear',
      appear === 'slow' && 'loader-wrapper-appear slow',
      className
    );
  }, [useAbsoluteWrapper, className]);

  const wrapperStyle = useMemo(() => {
    return {
      minWidth: size,
      minHeight: size,
      ...style
    };
  }, [style, size]);

  const innerStyle = useMemo(() => {
    return {
      width: size,
      height: size
    };
  }, [size]);

  const color = useMemo<string>(() => {
    if (colorCode === 'white') return '#FFF';
    if (colorCode === 'invalid') return '#FFD029';
    return '#FF009C';
  }, [colorCode]);

  return (
    <div className={wrapperClassName} style={wrapperStyle}>
      <div className='loader' style={innerStyle}>
        <SVGLogo color={color} onClick={onClick} />
      </div>
    </div>
  );
};

export default Loader;
